import api from '../../api/backend';

import {
        USER_LOGIN_REQUEST,
        USER_LOGIN_FAIL,
        USER_LOGIN_SUCCESS,
        USER_LOGOUT,
        USER_REGISTER_FAIL,
        USER_REGISTER_REQUEST,
        USER_REGISTER_SUCCESS
    } from './userConstants';

export const login = (user) => async (dispatch) => {
        try{
                dispatch({type : USER_LOGIN_REQUEST});

                const config = {
                        headers : {
                                'Content-Type' : 'application/json'
                        }
                }

                const {data} = await api.post('/api/users/login', user, config);

                dispatch({type : USER_LOGIN_SUCCESS, payload : data})

                localStorage.setItem('userInfo', JSON.stringify(data));
        }catch(err) {
                let error = err.response && err.response.data.message ? err.response.data.message : err.message;

                dispatch({type : USER_LOGIN_FAIL, payload : error});
        }
}

export const logout = () => (dispatch) =>{
        localStorage.removeItem('userInfo')
        dispatch({type : USER_LOGOUT})
}

export const register = (user) => async (dispatch) => {
        try{
                dispatch({type : USER_REGISTER_REQUEST});

                const config = {
                        headers : {
                                'Content-Type' : 'application/json'
                        }
                }

                const {data} = await api.post('/api/users/register', user, config);

                dispatch({type : USER_LOGIN_SUCCESS, payload : data})
                dispatch({type : USER_REGISTER_SUCCESS, payload : data})

                localStorage.setItem('userInfo', JSON.stringify(data));
        }catch(err) {
                let error = err.response && err.response.data.message ? err.response.data.message : err.message;

                dispatch({type : USER_REGISTER_FAIL, payload : error});
        }
}



